import { parse } from "../utils";

export default {
  "post|Report/GetList": (option) => {
    const pageSize = parseInt(parse("pageSize", option.url));
    let list = [
      {
        cover: require("@/assets/images/c02-01-1.png"),
        link: "/research/detail",
        title: "サイバー人材需給逼迫1111",
        catagory: "トレンド",
        publicDate: "2020-01-01 09:12:08",
        updateDate: "0001-01-01T00:00:00",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
        tagModel: [
          {
            itemid: "00000000-0000-0000-0000-000000000000",
            text: "その他変更テストその他収益性向上変更テストその他収益性向上",
            tcode: "t1_1",
            type: "report",
            children: null,
          },
          {
            itemid: "00000000-0000-0000-0000-000000000000",
            text: "変更テスト",
            tcode: "z1_08",
            children: null,
          },
          {
            itemid: "00000000-0000-0000-0000-000000000000",
            text: "Social",
            tcode: "z1_07",
            children: null,
          },
          {
            itemid: "00000000-0000-0000-0000-000000000000",
            text: "変更テストその他収益性向上",
            tcode: "z1_09",
            children: null,
          },
        ],
      },
      {
        cover: require("@/assets/images/c02-01-2.png"),
        link: "/research/detail",
        title: "サイバー人材需給逼迫2",
        catagory: "ピックアップニュース",
        publicDate: "2020-01-01 09:12:08",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
        tagModel: [
          {
            itemid: "00000000-0000-0000-0000-000000000000",
            text: "収益性向上",
            tcode: "z2_01",
            children: null,
          },
          {
            itemid: "00000000-0000-0000-0000-000000000000",
            text: "変更テスト",
            tcode: "z1_08",
            children: null,
          },
          {
            itemid: "00000000-0000-0000-0000-000000000000",
            text: "Social",
            tcode: "z1_07",
            children: null,
          },
          {
            itemid: "00000000-0000-0000-0000-000000000000",
            text: "変更テストその他収益性向上",
            tcode: "z1_09",
            children: null,
          },
        ],
      },
      {
        cover: require("@/assets/images/c02-01-3.png"),
        link: "/research/detail",
        title: "サイバー人材需給逼迫3",
        catagory: "トレンド",
        publicDate: "2020-01-01 09:12:08",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
        tagModel: [
          {
            itemid: "00000000-0000-0000-0000-000000000000",
            text: "収益性向上",
            tcode: "z2_01",
            children: null,
          },
        ],
      },
      {
        cover: require("@/assets/images/c02-01-4.png"),
        link: "/research/detail",
        title: "サイバー人材需給逼迫4",
        catagory: "トレンド",
        publicDate: "2020-01-01 09:12:08",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
        tagModel: [
          {
            itemid: "00000000-0000-0000-0000-000000000000",
            text: "収益性向上",
            tcode: "z2_01",
            children: null,
          },
        ],
      },
      {
        cover: require("@/assets/images/c02-01-5.png"),
        link: "/research/detail",
        title: "サイバー人材需給逼迫5",
        catagory: "トレンド",
        publicDate: "2020-01-01 09:12:08",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
        tagModel: [
          {
            itemid: "00000000-0000-0000-0000-000000000000",
            text: "収益性向上",
            tcode: "z2_01",
            children: null,
          },
        ],
      },
      {
        cover: require("@/assets/images/c02-01-6.png"),
        link: "/research/detail",
        title: "サイバー人材需給逼迫6",
        catagory: "ピックアップニュース",
        publicDate: "2020-01-01 09:12:08",
        summary:
          "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
        tagModel: [
          {
            itemid: "00000000-0000-0000-0000-000000000000",
            text: "収益性向上",
            tcode: "z2_01",
            children: null,
          },
        ],
      },
    ];
    if (pageSize === 10) {
      list = list.concat([
        {
          cover: require("@/assets/images/c02-01-7.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫7",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "収益性向上",
              tcode: "z2_01",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-8.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫8",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "収益性向上",
              tcode: "z2_01",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-9.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫9",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "その他",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c03-02-1.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫10",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "その他",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
          ],
        },
      ]);
    } else if (pageSize === 9) {
      list = list.concat([
        {
          cover: require("@/assets/images/c02-01-7.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫7",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "その他",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-8.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫8",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "その他",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
          ],
        },
        {
          cover: require("@/assets/images/c02-01-9.png"),
          link: "/research/detail",
          title: "サイバー人材需給逼迫9",
          catagory: "トレンド",
          publicDate: "2020-01-01 09:12:08",
          summary:
            "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス",
          tagModel: [
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "その他",
              tcode: "z1_01",
              children: null,
            },
            {
              itemid: "00000000-0000-0000-0000-000000000000",
              text: "変更テスト",
              tcode: "z1_08",
              children: null,
            },
          ],
        },
      ]);
    }
    return {
      code: 200,
      msg: "操作成功",
      data: {
        totalCount: list.length * 5,
        list,
      },
    };
  },
  "post|Report/related": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: {
        totalCount: 4,
        list: [
          {
            cover: require("@/assets/images/c02-01-1.png"),
            link: "/research/detail",
            title: "サイバー人材需給逼迫1",
            catagory: "トレンド",
            publicDate: "2020-01-01 09:12:08",
            summary:
              "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text:
                  "その他変更テストその他収益性向上変更テストその他収益性向上",
                tcode: "z1_01",
                children: null,
              },
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "変更テスト",
                tcode: "z1_08",
                children: null,
              },
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "Social",
                tcode: "z1_07",
                children: null,
              },
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "変更テストその他収益性向上",
                tcode: "z1_09",
                children: null,
              },
            ],
          },
          {
            cover: require("@/assets/images/c02-01-2.png"),
            link: "/research/detail",
            title: "サイバー人材需給逼迫2",
            catagory: "ピックアップニュース",
            publicDate: "2020-01-01 09:12:08",
            summary:
              "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス...M（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z2_01",
                children: null,
              },
            ],
          },
          {
            cover: require("@/assets/images/c02-01-3.png"),
            link: "/research/detail",
            title: "サイバー人材需給逼迫3",
            catagory: "トレンド",
            publicDate: "2020-01-01 09:12:08",
            summary:
              "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z2_01",
                children: null,
              },
            ],
          },
          {
            cover: require("@/assets/images/c02-01-4.png"),
            link: "/research/detail",
            title: "サイバー人材需給逼迫4",
            catagory: "トレンド",
            publicDate: "2020-01-01 09:12:08",
            summary:
              "将来のサイバー人材を生み出す観点でも、日本は後れを取っている。人材派遣のヒューマンリソシア（東京・新宿）は7月、STEM（科学、技術、工学、数学）分野の卒業者数に関する調査を発表した。対象となる92の国・地域のうち、日本は13位の3万人。インド（114万人）や米国（28万人）のみならず、英国（10万人）やフランス......",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z2_01",
                children: null,
              },
            ],
          },
        ],
      },
    };
  },
  "post|Report/Search": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: {
        totalCount: 25,
        list: [
          {
            link: "/research/detail",
            title: "1札幌観光MaaS「札ナビ」、2月実証実験",
            publicDate: "2021.04.16",
            catagory: "リサーチ情報",
            summary:
              "札幌型全国消費者物価指数(観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi（ナ...",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text:
                  "その他変更テストその他収益性向上変更テストその他収益性向上",
                tcode: "t1_1",
                type: "report",
                children: null,
              },
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "変更テスト",
                tcode: "t1_2",
                type: "report",
                children: null,
              },
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "Social",
                tcode: "t1_3",
                type: "report",
                children: null,
              },
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "変更テストその他収益性向上",
                tcode: "z1_09",
                children: null,
              },
            ],
          },
          {
            link: "/research/detail",
            title: "2札幌観光MaaS「札ナビ」、2月実証実験",
            publicDate: "2021.04.16",
            catagory: "リサーチ情報",
            summary:
              "札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi（ナ...",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z2_01",
                children: null,
              },
            ],
          },
          {
            link: "/research/detail",
            title: "3札幌観光MaaS「札ナビ」、2月実証実験",
            publicDate: "2021.04.16",
            catagory: "リサーチ情報",
            summary:
              "札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi（ナ...",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z2_01",
                children: null,
              },
            ],
          },
          {
            link: "/research/detail",
            title: "4札幌観光MaaS「札ナビ」、2月実証実験",
            publicDate: "2021.04.16",
            catagory: "リサーチ情報",
            summary:
              "札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi（ナ...",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z2_01",
                children: null,
              },
            ],
          },
          {
            link: "/research/detail",
            title: "5札幌観光MaaS「札ナビ」、2月実証実験",
            publicDate: "2021.04.16",
            catagory: "リサーチ情報",
            summary:
              "札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi（ナ...",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z2_01",
                children: null,
              },
            ],
          },
          {
            link: "/research/detail",
            title: "6札幌観光MaaS「札ナビ」、2月実証実験",
            publicDate: "2021.04.16",
            catagory: "リサーチ情報",
            summary:
              "札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi（ナ...",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z2_01",
                children: null,
              },
            ],
          },
          {
            link: "/research/detail",
            title: "7札幌観光MaaS「札ナビ」、2月実証実験",
            publicDate: "2021.04.16",
            catagory: "リサーチ情報",
            summary:
              "札幌型観光MaaS推進官民協議会は2月から、利用者の属性などに応じて観光地や移動手段を提案するウェブアプリ「札Navi（ナ...",
            tagModel: [
              {
                itemid: "00000000-0000-0000-0000-000000000000",
                text: "収益性向上",
                tcode: "z2_01",
                children: null,
              },
            ],
          },
        ],
      },
    };
  },
  "get|Report/getItemTags": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: [
        {
          itemid: "00000000-0000-0000-0000-000000000000",
          text: "その他",
          tcode: "t1_1",
          type: "report",
          children: null,
        },
        {
          itemid: "00000000-0000-0000-0000-000000000000",
          text: "変更テスト",
          tcode: "z1_08",
          children: null,
        },
        {
          itemid: "00000000-0000-0000-0000-000000000000",
          text: "Social",
          tcode: "z1_07",
          children: null,
        },
        {
          itemid: "00000000-0000-0000-0000-000000000000",
          text: "変更テストその他収益性向上",
          tcode: "z1_09",
          children: null,
        },
      ],
    };
  },
  "get|api/v1/sitecore/contents-delivery-evaluation-button-status": (
    option
  ) => {
    return {
      status: 200,
      error: false,
      data: {
        dataExistFlag: true,
        contentsDeliveryEvaluationButtonStatus: {
          reportId: 'reportId',
          userId: 'userId',
          buttonStatus: '1',	
          publicationDate: '2022/05/11',
          reportTitle: 'reportTitle'
        },
        secureToken: "6f6844081a9a109575e01abd06b9e127f18da52044a62c873ad2818059e3a09e",
      },
    };
  },
  "post|api/v1/sitecore/contents-delivery-evaluation-button-status": (
    option
  ) => {
    return {
      error: false,
    };
  },
};
